import { render, staticRenderFns } from "./RiderLocationAreas.vue?vue&type=template&id=088cb634"
import script from "./RiderLocationAreas.vue?vue&type=script&lang=js"
export * from "./RiderLocationAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports